import { statuses } from "./statuses";

const sectionsList = [
  {
    scopes: ["admin"],
    to: { name: "files-list", params: { state: "all" } },
    iconName: "FileIcon",
  },
  {
    scopes: ["admin"],
    to: { name: "files-list", params: { state: 5 } },
    iconName: "ViewBatchIcon",
  },
  {
    scopes: ["admin", "annotator"],
    to: { name: "files-list", params: { state: 0 } },
    iconName: "LetterOpenedIcon",
  },
  {
    scopes: ["admin", "annotator"],
    to: { name: "files-list", params: { state: 1 } },
    iconName: "PenIcon",
  },
  {
    scopes: ["admin", "annotator", "verifier"],
    to: { name: "files-list", params: { state: 2 } },
    iconName: "AnnotatedIcon",
  },
  {
    scopes: ["admin", "annotator", "verifier"],
    to: { name: "files-list", params: { state: 3 } },
    iconName: "ToVerifiedIcon",
  },
  {
    scopes: ["admin", "annotator", "verifier"],
    to: { name: "files-list", params: { state: 4 } },
    iconName: "VerifiedIcon",
  },
  // {
  //   scopes: ["admin"],
  //   to: { name: "files-list", params: { state: 5 } },
  // },
  {
    scopes: ["admin"],
    to: { name: "files-list", params: { state: 6 } },
    iconName: "ArchiveIcon",
  },
].map((item) => {
  const status = statuses[item.to.params.state];
  return {
    ...item,
    title: status.pluralTitle,
  };
});

export function getSections(scope) {
  return sectionsList.filter((item) => item.scopes.includes(scope));
}

export function getSection(state) {
  return sectionsList.find((si) => si.to.params.state === state);
}
